/* global  APPLICATION_VERSION */

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import ls from './utils/local-storage';
import ss from './utils/session-storage';
import Vuelidate from 'vuelidate';
import { ClientTable } from 'vue-tables-2';

// 語系包
import VueI18n from 'vue-i18n';
import enLocale from './lang/en-US.json';
import deLocale from './lang/de.json';
import nlLocale from './lang/nl.json';

// bootstrap 3
import 'bootstrap';
import 'bootstrap-select';

// import uiv from 'uiv'
import * as uiv from 'uiv';

// Charts
import VCharts from 'v-charts';

// Html2Canvas
import html2canvas from 'html2canvas';

// Sentry Service
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
window.html2canvas = html2canvas;

Vue.prototype.$bus = new Vue();
Vue.use(VueI18n);
Vue.use(Vuelidate);
Vue.use(ClientTable, {}, false, 'bootstrap3', 'default');
Vue.use(uiv, { prefix: 'uiv' });
Vue.use(VCharts);

Vue.mixin({
  methods: {
    errMsgDialog (msg) {
      // msg = { show: bool, tag: string, errCode: string, btnOk: string, title: string }
      // console.log(msg)
      // console.log(this.modal)
      // 是否有標籤碼
      if (msg.tag) {
        this.modalOpenError = msg.show;
        this.modal.data.content = `[${msg.tag}] - [${msg.errCode}] ${this.$t('errorCodeMsg.' + msg.errCode)}`;
      } else if (msg.disconnectMG) {
        this.modalOpenDisconnect = msg.show;
        this.modal.data.content = this.$t('errorCodeMsg.ExecuteMG');
      } else {
        this.modalOpenDisconnect = msg.show;
        this.modal.data.content = `[${msg.errCode}] ${this.$t('errorCodeMsg.' + msg.errCode)}`;
      }

      if (msg.title) {
        this.modal.data.title = msg.title;
      }
      if (msg.btnOk) {
        this.modal.btn.ok = msg.btnOk;
      }
    }
  }
});

const messages = {
  en: {
    ...enLocale
  },
  de: {
    ...deLocale
  },
  nl: {
    ...nlLocale
  }
};

const i18n = new VueI18n({
  locale: ls.getItem('lang') || 'en', // set locale
  messages // set locale messages
});

/**
 * Sentry setting
 */
Sentry.init({
  dsn: 'https://a8f7d143971a4ea3a3c3f3e76601679e@sentry.io/1802959',
  integrations: [
    new Integrations.Vue({ Vue, attachProps: true, logErrors: true })
  ],
  release: APPLICATION_VERSION,
  environment: process.env.NODE_ENV
});

router.beforeEach((to, from, next) => {
  // 設計一個須"經過connect page"才能進去的機制
  // 沒有BikeID 的情形下，可以進入changeBike & connect fail page
  if (!ss.getItem('bikeId') && to.path !== '/connect') {
    if (to.path === '/changebike') {
      next();
    } else if (to.path === '/connect/failed/ComportError') {
      next();
    } else if (to.path === '/connect/failed/PowerError') {
      next();
    } else if (to.path === '/connect/failed/APIError') {
      next();
    } else if (to.path === '/connect/failed/BikeError') {
      next();
    } else if (to.path === '/connect/failed/ReadInfoError') {
      next();
    } else if (to.path === '/connect/failed/WriteInfoError') {
      next();
    } else if (to.path === '/connect/failed/PNError') {
      next();
    } else if (to.path === '/vinrecheck') {
      next();
    } else if (to.path === '/writevin') {
      next();
    } else if (to.path === '/coverbikedata') {
      next();
    } else if (to.path === '/re-fwupdate') {
      next();
    } else if (to.path === '/support') {
      next();
    } else if (to.path === '/') {
      next();
    } else {
      next('/connect');
    }
  } else {
    next();
  }
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
